// removed by extract-text-webpack-plugin
module.exports = {"list":"MessagesList-module__list___3BpBh","icon":"MessagesList-module__icon___tVd6Y","item":"MessagesList-module__item___1RwLf","date-location":"MessagesList-module__date-location___1y2po","date-icon":"MessagesList-module__date-icon___15E_G","location-icon":"MessagesList-module__location-icon___1kJB2","message":"MessagesList-module__message___29IGw","mobile":"MessagesList-module__mobile___BgGgA"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/CarrierMessages/MessagesList/MessagesList.module.scss
// module id = 261
// module chunks = 0 1